import React, { useState, useEffect, useContext, useMemo, useRef, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Modal, Button, Spinner } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "./Pagination";
import MyContext from "../../MyContext";
import { Row, Col } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import excel from "../../images/excel (2).svg";
import Placeholder from "../../images/Place Holder 3 1.webp";
import Placeholder1 from "../../images/Place Holder.webp";
import Placeholder2 from "../../images/Place Holder_1.webp";
import loader from "../../images/Sendbulkmessage.svg";
import refreshicon from "../../images/refresh-2.svg";
import * as XLSX from "xlsx";

/* ---------- small helpers ---------- */
const EntryFields = ({ entriesValue, onEntriesChange, pageNumber, onPageNumberChange }) => {
  const entriesOptions = [1000, 5000, 10000, 100000];
  return (
    <Row className="align-items-center g-3">
      <Col xs="auto">
        <Form.Group className="d-flex align-items-center gap-2">
          <Form.Label className="mb-0 text-nowrap">No. of entries:</Form.Label>
          <Form.Select
            size="sm"
            value={entriesValue}
            onChange={onEntriesChange}
            style={{ width: "100px", height: "35px" }}
          >
            {entriesOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>

      <Col xs="auto">
        <Form.Group className="d-flex align-items-center gap-2">
          <Form.Label className="mb-0 text-nowrap">Page No:</Form.Label>
          <Form.Control
            size="sm"
            type="number"
            value={pageNumber}
            onChange={onPageNumberChange}
            min={1}
            style={{ width: "70px", height: "35px" }}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

/* --- Drop-in styles --- */
const modalBackdrop = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.45)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalCard = {
  background: "#fff",
  width: "90%",
  maxWidth: 1200,
  maxHeight: "85vh",
  borderRadius: 12,
  boxShadow: "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

const modalHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "16px 20px",
  borderBottom: "1px solid #f0f0f0",
  background: "#fafafa",
};

const titleWrap = { display: "flex", alignItems: "baseline", gap: 12 };
const titleH2 = { margin: 0, fontSize: 18, fontWeight: 700 };
const subInfo = { fontSize: 13, color: "#6c757d" };

const closeIconBtn = {
  border: "none",
  background: "transparent",
  fontSize: 22,
  lineHeight: 1,
  cursor: "pointer",
  padding: 6,
  borderRadius: 8,
};

const headerActions = { display: "flex", alignItems: "center", gap: 10 };

const tableWrap = { overflow: "auto", maxHeight: "70vh" };

const tableStyle = {
  width: "100%",
  borderCollapse: "separate",
  borderSpacing: 0,
};

const thSticky = {
  position: "sticky",
  top: 0,
  background: "#f7f7f9",
  color: "#333",
  textAlign: "left",
  padding: "10px 12px",
  fontSize: 13,
  fontWeight: 700,
  borderBottom: "1px solid #e9ecef",
  zIndex: 1,
};

const tdStyle = {
  padding: "10px 12px",
  borderBottom: "1px solid #f1f3f5",
  fontSize: 13,
};

const centerCell = {
  textAlign: "center",
  padding: "18px",
  color: "#6c757d",
  fontSize: 14,
};

const footerBar = {
  padding: "12px 16px",
  borderTop: "1px solid #f0f0f0",
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  background: "#fff",
};

const primaryBtn = {
  padding: "8px 14px",
  borderRadius: 8,
  border: "1px solid #198754",
  background: "#198754",
  color: "#fff",
  cursor: "pointer",
};

const dangerBtn = {
  padding: "8px 14px",
  borderRadius: 8,
  border: "1px solid #dc3545",
  background: "#dc3545",
  color: "#fff",
  cursor: "pointer",
};

const badge = {
  padding: "3px 8px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 600,
  border: "1px solid #dee2e6",
  background: "#fff",
  color: "#495057",
};

const spinner = {
  display: "inline-block",
  width: 28,
  height: 28,
  border: "3px solid #e9ecef",
  borderTopColor: "#227D52",
  borderRadius: "50%",
  animation: "spin 0.8s linear infinite",
};
/* Add once globally:
@keyframes spin { to { transform: rotate(360deg); } }
*/

const StatusBadge = ({ status }) => {
  const getStatusStyles = (status) => {
    const baseStyle = {
      padding: "4px 12px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: "500",
      display: "inline-block",
      textTransform: "capitalize",
      minWidth: "120px",
      textAlign: "center",
    };

    const statusStyles = {
      delivered: { backgroundColor: "#E5F6ED", color: "#0B7D3E", border: "1px solid #A6E5C6" },
      failed: { backgroundColor: "#FFEBEB", color: "#DE350B", border: "1px solid #FFBDBD" },
      read: { backgroundColor: "#EEF6FF", color: "#0052CC", border: "1px solid #B3D4FF" },
      interested: { backgroundColor: "#FFF7E6", color: "#B76E00", border: "1px solid #FFE5B3" },
      accepted: { backgroundColor: "#E6F7FF", color: "#0073B7", border: "1px solid #A3DAFF" },
      submitted: { backgroundColor: "#F6E5E5", color: "#7D0B0B", border: "1px solid #E5A6A6" },
      reply: { backgroundColor: "rgb(129, 160, 2 , 0.1)", color: "rgb(129, 160, 2)", border: "1px solid rgb(129, 160, 2)" },
      Completed: { backgroundColor: "#E5F6ED", color: "#0B7D3E", border: "1px solid #A6E5C6" },
      Stopped: { backgroundColor: "#FFEBEB", color: "#DE350B", border: "1px solid #FFBDBD" },
      Running: { backgroundColor: "rgb(129, 160, 2 , 0.1)", color: "rgb(129, 160, 2)", border: "1px solid rgb(129, 160, 2)" },
      Failed: { backgroundColor: "#FFEBEB", color: "#DE350B", border: "1px solid #FFBDBD" },
      Started: { backgroundColor: "#edffebff", color: "#7cde0bff", border: "1px solid #acfca9ff" },
      delivered_null: { backgroundColor: "#F8F9FA", color: "#6C757D", border: "1px solid #DEE2E6" },
    };

    return { ...baseStyle, ...(statusStyles[status] || statusStyles.delivered_null) };
  };

  return (
    <span style={getStatusStyles(status)}>
      {status ?? "—"}
    </span>
  );
};


const StatusTemplateBadge = ({ templateID, templates }) => {
  const template = templates?.find((item) => item.name === templateID);
  const extractHeaderAndBody = (t) => {
    let headerText = "";
    let bodyText = "";
    if (t && Array.isArray(t.components)) {
      t.components.forEach((c) => {
        if (c.type === "HEADER" && c.text) headerText = c.text;
        if (c.type === "BODY" && c.text) bodyText = c.text;
      });
    }
    return { headerText, bodyText };
  };
  const Message = extractHeaderAndBody(template);

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{Message.headerText} {Message.bodyText}</Tooltip>}>
      <span>{templateID}</span>
    </OverlayTrigger>
  );
};

const Logs = ({ userID }) => {
  const { baseUrl, config } = useContext(MyContext);

  // tabs
  const [activeTab, setActiveTab] = useState("campaign"); // 'campaign' | 'message'

  // existing (Campaign Logs) state
  const [loading, setLoading] = useState(false);
  const [Campaign, setCampaign] = useState([]);
  const [LogsModalRows, setLogsModalRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [entriesValue, setEntriesValue] = useState(1000);
  const [pageNumber, setPageNumber] = useState(1);
  const [WhatsappNumbers, setWhatsappNumbers] = useState([]);
  const [MultiplePhoneNumber, setMultiplePhoneNumber] = useState(false);
  const [SingleWhatsApp, setSingleWhatsApp] = useState("");
  const [Status, setStatus] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [CampName, setCampName] = useState("");
  const [ModalLoading, setModalLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [animate, setAnimate] = useState(false);

  // new (Message Logs) state
  const todayISO = useMemo(() => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }, []);

  const twoDaysAgoISO = useMemo(() => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }, []);

  const [msgFromDate, setMsgFromDate] = useState(twoDaysAgoISO);
  const [msgToDate, setMsgToDate] = useState(todayISO);
  const [msgRows, setMsgRows] = useState([]);
  const [msgLoading, setMsgLoading] = useState(false);
  const [msgPage, setMsgPage] = useState(1);
  const [msgOffset] = useState(100);
  const [msgHasMore, setMsgHasMore] = useState(true);
  const msgSeenIdsRef = useRef(new Set());
  const msgScrollWrapRef = useRef(null);
  const msgLoadingRef = useRef(false);           // hard guard to prevent double fetch
  const abortCtrlRef = useRef(null);             // abort previous request if needed
  const sentinelRef = useRef(null);              // bottom observer sentinel

  /* ---------------- Campaign: existing logic ---------------- */
  const getLogs = async (status, id, name) => {
    try {
      setModalLoading(true);
      setIsOpen(true);
      setStatus(status);
      setCampName(name);
      setLogsModalRows([]);

      const raw = JSON.stringify({ userid: userID, campaignId: id, status });
      const requestOptions = { method: "POST", headers: config.headers, body: raw, redirect: "follow" };
      const res = await fetch(`${baseUrl}/api/Whatsapp/v1.0/getWhatsappLogs`, requestOptions);
      const data = await res.json();

      if (data?.responseCode === "00") setLogsModalRows(data.response);
    } catch (error) {
      console.log({ error });
    } finally {
      setModalLoading(false);
    }
  };

  const getCampaign = async () => {
    try {
      setLoading(true);
      const raw = JSON.stringify({ userid: userID, campaignName: "string", phoneNumberId: SingleWhatsApp });
      const requestOptions = { method: "POST", headers: config.headers, body: raw, redirect: "follow" };
      const res = await fetch(`${baseUrl}/api/Campaign/v1.0/getCampaigns`, requestOptions);
      const data = await res.json();
      if (data?.responseCode === "00") setCampaign(data?.data);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  const getWhatsappNumber = async () => {
    try {
      const raw = JSON.stringify({ userid: userID });
      const requestOptions = { method: "POST", headers: config.headers, body: raw, redirect: "follow" };
      const res = await fetch(`${baseUrl}/api/Whatsapp/v1.0/getWhatsappNumbers`, requestOptions);
      const data = await res.json();
      if (data?.responseCode === "00") setWhatsappNumbers(data?.response);
    } catch (error) { }
  };

  const getTemplates = async () => {
    try {
      const raw = JSON.stringify({ userid: userID, phoneNumberId: SingleWhatsApp });
      const requestOptions = { method: "POST", headers: config.headers, body: raw, redirect: "follow" };
      const res = await fetch(`${baseUrl}/api/Whatsapp/v1.0/getTemplates`, requestOptions);
      const data = await res.json();
      if (data?.responseCode === "00") setTemplates(data?.response.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  useEffect(() => {
    getWhatsappNumber();
  }, []);

  useEffect(() => {
    if (WhatsappNumbers && WhatsappNumbers.length === 1) {
      setMultiplePhoneNumber(false);
      WhatsappNumbers.forEach((Num) => setSingleWhatsApp(Num.phone_no_id));
    } else if (WhatsappNumbers && WhatsappNumbers.length !== 1) {
      setMultiplePhoneNumber(true);
      WhatsappNumbers.forEach((Num, i) => (i === 0 ? setSingleWhatsApp(Num.phone_no_id) : ""));
    }
  }, [WhatsappNumbers]);

  useEffect(() => {
    if (!SingleWhatsApp) return;
    getCampaign();
    getTemplates();
  }, [SingleWhatsApp]);

  useEffect(() => {
    setAnimate(false);
    const t = setTimeout(() => setAnimate(true), 10);
    return () => clearTimeout(t);
  }, [templates]);

  const replaceVariablesBody = (text) => {
    const replacements = ["John Doe", "Messaging"]; // demo only
    return text.replace(/{{(\d+)}}/g, (_, index) => replacements[index - 1] || "");
  };

  const downloadExcelModal = () => {
    if (!Array.isArray(LogsModalRows) || LogsModalRows.length === 0) return;
    const headers = [
      ["ID", "Contact", "Status", "Date", "Product", "Category", "Contact Name", "Message Category", "Error Code", "Error Description"],
    ];
    const logsData = LogsModalRows.map((item) => [
      item.id,
      item.contact,
      item.status,
      item.indate,
      item.product,
      item.category,
      item.contact_name || "N/A",
      item.message_category,
      item.error_code || "N/A",
      item.error || "N/A",
    ]);
    const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...logsData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Logs Report");
    XLSX.writeFile(workbook, `Whatsapp_Logs_${CampName}_${Status}.xlsx`);
  };

  const refreshCampaigns = () => getCampaign();

  /* ---------------- Message Logs: new logic ---------------- */
  const resetMessageLogs = useCallback(() => {
    // Abort any in-flight call
    if (abortCtrlRef.current) {
      try { abortCtrlRef.current.abort(); } catch { }
    }
    // Clear guards and state
    msgLoadingRef.current = false;
    setMsgLoading(false);
    setMsgRows([]);
    setMsgPage(1);
    setMsgHasMore(true);
    msgSeenIdsRef.current = new Set();
  }, []);



  const fetchMessageLogs = useCallback(
    async (pageToFetch = 1) => {
      if (msgLoadingRef.current || msgLoading || !msgHasMore) return;

      // lock
      msgLoadingRef.current = true;
      setMsgLoading(true);

      // abort any previous fetch (e.g., fast date changes)
      if (abortCtrlRef.current) {
        try { abortCtrlRef.current.abort(); } catch { }
      }
      const ctrl = new AbortController();
      abortCtrlRef.current = ctrl;

      try {
        const payload = {
          userid: String(userID || "").trim(),
          fromDate: msgFromDate,
          toDate: msgToDate,
          page: String(pageToFetch),        // page 1,2,3...
          offset: String(msgOffset),        // always "100"
        };

        const res = await fetch(
          `${baseUrl}/api/Whatsapp/getAllWhatsappLogs`,
          {
            method: "POST",
            headers: { ...config.headers, "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            redirect: "follow",
            signal: ctrl.signal,
          }
        );

        const data = await res.json();

        if (data?.responseCode !== "00") {
          setMsgHasMore(false);
          return;
        }

        const incoming = Array.isArray(data.response) ? data.response : [];

        // de-dupe by id while appending
        const next = [];
        for (const row of incoming) {
          const id = row?.id;
          if (!id) continue;
          if (!msgSeenIdsRef.current.has(id)) {
            msgSeenIdsRef.current.add(id);
            next.push(row);
          }
        }

        // If the API returned < offset OR we didn’t add anything new, we are done.
        if (incoming.length < Number(msgOffset) || next.length === 0) {
          if (next.length > 0) setMsgRows((prev) => [...prev, ...next]);
          setMsgHasMore(false);
          return;
        }

        // Normal append + advance page
        setMsgRows((prev) => [...prev, ...next]);
        setMsgPage((p) => p + 1);
      } catch (e) {
        if (e?.name !== "AbortError") {
          console.error(e);
          setMsgHasMore(false);
        }
      } finally {
        setMsgLoading(false);
        msgLoadingRef.current = false;
      }
    },
    [msgFromDate, msgToDate, msgOffset, msgLoading, msgHasMore, userID, baseUrl, config.headers]
  );



  // initial + on tab change to message
  useEffect(() => {
    if (activeTab !== "message") return;
    if (msgRows.length === 0) fetchMessageLogs(1);
  }, [activeTab]); // eslint-disable-line

  // when dates change and user clicks Apply, we call reset + fetch(1)
  const onApplyDateFilter = () => {
    if (new Date(msgFromDate) > new Date(msgToDate)) {
      toast.error("From date cannot be after To date");
      return;
    }
    // reset guards + state
    resetMessageLogs();
    // kick the first page
    fetchMessageLogs(1);
  };


  // infinite scroll handler
  const onMsgScroll = (e) => {
    const el = e.currentTarget;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 120;
    if (nearBottom && msgHasMore && !msgLoading) {
      fetchMessageLogs(msgPage);
    }
  };

  /* ---------------- derived / UI bits ---------------- */
  const totalPages = Math.ceil(Campaign.length / itemsPerPage);
  const handlePageClick = (page) => setCurrentPage(page);
  const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const handlePrevPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  const sortedCampaign = useMemo(
    () => [...Campaign].sort((a, b) => new Date(b.indate) - new Date(a.indate)),
    [Campaign]
  );

  const displayedItems = useMemo(
    () => sortedCampaign.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage),
    [sortedCampaign, currentPage]
  );

  const handlePreview = (templateId) => {
    setIsLoading(true);
    setShowModal(true);
    const template = templates.find((temp) => temp.name === templateId);
    setSelectedTemplate(template);
    setIsLoading(false);
  };
  // Hook the sentinel for smooth, single-fire loads
  useEffect(() => {
    if (activeTab !== "message") return;

    const rootEl = msgScrollWrapRef.current;
    const targetEl = sentinelRef.current;
    if (!rootEl || !targetEl) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && msgHasMore && !msgLoadingRef.current) {
          fetchMessageLogs(msgPage);
        }
      },
      {
        root: rootEl,                 // must be ancestor of targetEl
        rootMargin: "0px 0px 200px 0px",
        threshold: 0,
      }
    );

    observer.observe(targetEl);
    return () => observer.disconnect();
  }, [activeTab, fetchMessageLogs, msgHasMore, msgPage]);



  return (
    <>
      <div className="d-flex justify-content-center text-center">
        <ToastContainer />
      </div>

      {/* Tabs header */}
      <div className="px-4 pt-3">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "campaign" ? "active" : ""}`}
              onClick={() => setActiveTab("campaign")}
            >
              Campaign Logs
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "message" ? "active" : ""}`}
              onClick={() => setActiveTab("message")}
            >
              Message Logs
            </button>
          </li>
        </ul>
      </div>

      {/* Template preview modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Message Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" />
              <p>Generating preview...</p>
            </div>
          ) : selectedTemplate ? (
            <div>
              <div className="p-5 bg-light">
                <div className={`message-bubble border ${animate ? "message-bubble-animate " : ""}`}>
                  <div className="d-flex justify-content-center">
                    {selectedTemplate.components?.find((c) => c.format === "IMAGE") ? (
                      <img src={Placeholder} alt="" style={{ width: "14rem" }} />
                    ) : (
                      ""
                    )}
                    {selectedTemplate.components?.find((c) => c.format === "VIDEO") ? (
                      <img src={Placeholder1} alt="" style={{ width: "14rem" }} />
                    ) : (
                      ""
                    )}
                    {selectedTemplate.components?.find((c) => c.format === "DOCUMENT") ? (
                      <img src={Placeholder2} alt="" style={{ width: "14rem" }} />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="header-text">
                    {selectedTemplate.components?.find((c) => c.type === "HEADER")?.text || ""}
                  </div>
                  <div className="body-text py-1">
                    <div>
                      {replaceVariablesBody(selectedTemplate.components?.find((c) => c.type === "BODY")?.text || "")}
                    </div>
                  </div>
                  <div className="footer-text">
                    {selectedTemplate.components?.find((c) => c.type === "FOOTER")?.text || ""}
                  </div>
                  <div className="footer-text text-end">05:27 PM</div>
                </div>

                {selectedTemplate.components
                  ?.find((c) => c.type === "BUTTONS")
                  ?.buttons?.map((button, index) => (
                    <div key={index} className={`button-bubble ${animate ? "button-bubble-animate border mt-2" : ""}`}>
                      <div className="button-text text-success text-center mb-1">{button.text}</div>
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            <p>No template found.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------ CAMPAIGN LOGS TAB ------ */}
      {activeTab === "campaign" && (
        <div className="p-4 bg-white" style={{ minHeight: "80vh", fontFamily: "Nunito,sans-serif" }}>
          <div className="px-4 justify-content-center">
            <div className="Sendbulkmsg-campaign-container mb-4 bg-light">
              <div className="Sendbulkmsg-header d-flex justify-content-between">
                <h2 className="CreateCampaign">WhatsApp Campaign Logs</h2>
                <div className="d-flex">
                  <div className="Sendbulkmsg-actions">
                    <button className="Sendbulkmsg-refresh-btn text-success" onClick={refreshCampaigns}>
                      <img src={refreshicon} alt="Refresh" />
                    </button>
                  </div>
                </div>
              </div>

              <hr />

              <div className="Sendbulkmsg-controls d-flex justify-content-start">
                <div className="Sendbulkmsg-whatsapp ">
                  <label className="Sendbulkmsg-whatsapp-label single-line-css"> WhatsApp Number</label>
                  <select
                    className="Sendbulkmsg-whatsapp-dropdown"
                    value={SingleWhatsApp}
                    onChange={(e) => setSingleWhatsApp(e.target.value)}
                    disabled={!MultiplePhoneNumber}
                  >
                    <option value="">Select Number</option>
                    {WhatsappNumbers.map((num, index) => (
                      <option key={index} value={num.phone_no_id}>
                        {num.phone_no_id} - ({num.phone_no})
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {loading ? (
              <div className="m-5 p-5 d-flex justify-content-center">
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <div className="p-3">
                    <div className="loader"></div>
                  </div>
                  <div className="p-3">
                    <img src={loader} alt="" height={40} />
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="scrollable-table loading-list-chat mb-2">
                  <table className="table table-bordered table-hover">
                    <thead style={{ borderRadius: "10px" }}>
                      <tr className="text-center greenColour py-4" style={{ borderBottom: "1px solid #ccc" }}>
                        <th className="p-3 th-style">S.No.</th>
                        <th className="p-3 th-style">ID</th>
                        <th className="p-3 th-style">Campaign Name</th>
                        <th className="pb-3 th-style">Start Time</th>
                        <th className="p-3 th-style">Template</th>
                        <th className="p-3 th-style">Category</th>
                        <th className="p-3 th-style">Uploaded</th>
                        <th className="p-3 th-style">Duplicate</th>
                        <th className="p-3 th-style">Submitted</th>
                        <th className="p-3 th-style">Sent</th>
                        <th className="p-3 th-style">Delivered</th>
                        <th className="p-3 th-style">Accepted</th>
                        <th className="p-3 th-style">Read</th>
                        <th className="p-3 th-style">Failed</th>
                        <th className="p-3 th-style">Responded</th>
                        <th className="p-3 th-style">Preview</th>
                        <th className="p-3 th-style">Audience</th>
                        <th className="p-3 th-style">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayedItems.map((item, index) => (
                        <tr key={index} style={{ borderBottom: "1px solid #DDD", padding: "0px 0px" }}>
                          <td className=" text-center">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                          <td className="text-center">{item.id}</td>
                          <td className="text-center">{item.campaign_name?.toUpperCase()}</td>
                          <td className="text-center">{item.campaign_start}</td>
                          <td className="text-center cursor-pointer">
                            <StatusTemplateBadge templateID={item.template_id} templates={templates} />
                          </td>
                          <td className="text-center">
                            <b>{item.template_category}</b>
                          </td>
                          <td className="text-center">
                            <b>{item.uploaded || 0}</b>
                          </td>
                          <td className="text-center">
                            <b>{item.duplicate || 0}</b>
                          </td>
                          <td className="text-center">
                            <b>{item.submitted || 0}</b>
                          </td>
                          <td
                            className="text-center cursor-pointer clickable-text"
                            onClick={() => getLogs("sent", item.id, item.campaign_name)}
                          >
                            <b>{item.sent || 0}</b>
                          </td>
                          <td
                            className="text-center cursor-pointer clickable-text"
                            onClick={() => getLogs("delivered", item.id, item.campaign_name)}
                          >
                            <b>{item.delivered || 0}</b>
                          </td>
                          <td
                            className="text-center cursor-pointer clickable-text"
                            onClick={() => getLogs("accepted", item.id, item.campaign_name)}
                          >
                            <b>{item.accepted || 0}</b>
                          </td>
                          <td
                            className="text-center cursor-pointer clickable-text"
                            onClick={() => getLogs("read", item.id, item.campaign_name)}
                          >
                            <b>{item.read || 0}</b>
                          </td>
                          <td
                            className="text-center cursor-pointer clickable-text"
                            onClick={() => getLogs("failed", item.id, item.campaign_name)}
                          >
                            <b>{item.failed || 0}</b>
                          </td>
                          <td
                            className="text-center cursor-pointer clickable-text"
                            onClick={() => getLogs("responded", item.id, item.campaign_name)}
                          >
                            <b>{item.responded || 0}</b>
                          </td>
                          <td className="text-center cursor-pointer">
                            <button onClick={() => handlePreview(item.template_id)} className="btn text-success bg-light">
                              Preview
                            </button>
                          </td>
                          <td className="pt-4 text-center">
                            <a href={item.excel_url} download target="_blank" rel="noopener noreferrer" className="cursur-pointer ">
                              <img src={excel} alt="" height={30} />
                            </a>
                          </td>
                          <td className="text-center cursor-pointer">
                            <StatusBadge status={item.status} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="pb-4">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onNextPage={handleNextPage}
                    onPrevPage={handlePrevPage}
                    onPageClick={handlePageClick}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ------ MESSAGE LOGS TAB ------ */}
      {activeTab === "message" && (
        <div className="p-4 bg-white" style={{ minHeight: "90vh", fontFamily: "Nunito,sans-serif" }}>
          <div className="px-4 justify-content-center">
            <div className="Sendbulkmsg-campaign-container mb-3 bg-light">
              <div className="Sendbulkmsg-header d-flex justify-content-between align-items-center">
                <h2 className="CreateCampaign">WhatsApp Message Logs</h2>

                <div className="d-flex align-items-center gap-2">
                  <div>
                    <label className="form-label mb-1">From</label>
                    <input
                      type="date"
                      className="form-control"
                      value={msgFromDate}
                      onChange={(e) => setMsgFromDate(e.target.value)}
                      max={msgToDate}
                    />
                  </div>
                  <div>
                    <label className="form-label mb-1">To</label>
                    <input
                      type="date"
                      className="form-control"
                      value={msgToDate}
                      onChange={(e) => setMsgToDate(e.target.value)}
                      min={msgFromDate}
                      max={todayISO}
                    />
                  </div>
                  <button className="btn btn-success mt-4" onClick={onApplyDateFilter} disabled={msgLoading}>
                    {msgLoading ? "Filtering..." : "Apply"}
                  </button>
                </div>
              </div>
            </div>

            {/* Scrollable table with infinite loading */}
            <div
              style={{ ...tableWrap, border: "1px solid #eee", borderRadius: 8 }}
              // onScroll={onMsgScroll}
              ref={msgScrollWrapRef}
              className="loading-list-chat"
            >
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thSticky}>ID</th>
                    <th style={thSticky}>Contact</th>
                    <th style={thSticky}>Status</th>
                    <th style={thSticky}>Date</th>
                    <th style={thSticky}>Product</th>
                    <th style={thSticky}>Category</th>
                    <th style={thSticky}>Contact Name</th>
                    <th style={thSticky}>Message Category</th>
                    <th style={thSticky}>Error Code</th>
                    <th style={thSticky}>Error</th>
                  </tr>
                </thead>
                <tbody>
                  {msgRows.length === 0 && !msgLoading && (
                    <tr>
                      <td colSpan={10} style={centerCell}>
                        No data found
                      </td>
                    </tr>
                  )}

                  {msgRows.map((item) => (
                    <tr key={item.id}>
                      <td style={tdStyle}>{item.id}</td>
                      <td style={tdStyle}>{item.contact}</td>
                      <td style={tdStyle}>
                        <StatusBadge status={item.status} reason={item.error} />
                      </td>
                      <td style={tdStyle}>{item.indate}</td>
                      <td style={tdStyle}>{item.product}</td>
                      <td style={tdStyle}>{item.category}</td>
                      <td style={tdStyle}>{item.contact_name || "N/A"}</td>
                      <td style={tdStyle}>{item.message_category}</td>
                      <td style={tdStyle}>{item.error_code || "N/A"}</td>
                      <td style={tdStyle}>{item.error || "N/A"}</td>
                    </tr>
                  ))}

                  {msgLoading && (
                    <tr>
                      <td colSpan={10} style={centerCell}>
                        <span style={spinner} /> <div style={{ height: 8 }} />
                        Loading…
                      </td>
                    </tr>
                  )}
                  {!msgHasMore && msgRows.length > 0 && (
                    <tr>
                      <td colSpan={10} style={centerCell}>End of results</td>
                    </tr>
                  )}

                  {/* 👇 sentinel INSIDE the scrollable container */}
                  <tr>
                    <td colSpan={10}>
                      <div ref={sentinelRef} style={{ height: 1 }} />
                    </td>
                  </tr>
                </tbody>

              </table>
            </div>
            {/* IntersectionObserver sentinel */}
            {/* <div ref={sentinelRef} style={{ height: 1 }} /> */}
            {/* Small helper to manually fetch more (optional) */}
            <div className="d-flex justify-content-end mt-2">
              <button
                className="btn btn-outline-secondary"
                onClick={() => fetchMessageLogs(msgPage)}
                disabled={!msgHasMore || msgLoading}
              >
                {msgHasMore ? (msgLoading ? "Loading…" : "Load More") : "No More"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ------- Campaign logs modal ------- */}
      {isOpen && (
        <div
          role="dialog"
          aria-modal="true"
          style={modalBackdrop}
          onClick={() => {
            setIsOpen(false);
            setLogsModalRows([]);
          }}
        >
          <div
            style={modalCard}
            onClick={(e) => e.stopPropagation()} // prevent backdrop-close when clicking inside
          >
            <div style={modalHeader}>
              <div style={titleWrap}>
                <h2 style={titleH2}>
                  {CampName} — {Status?.toUpperCase()}
                </h2>
                <span style={badge}>Total: {Array.isArray(LogsModalRows) ? LogsModalRows.length : 0}</span>
              </div>

              <div style={headerActions}>
                {/* {Array.isArray(LogsModalRows) && LogsModalRows.length > 0 && (
                  <button onClick={downloadExcelModal} style={primaryBtn}>
                    Download Excel Report
                  </button>
                )} */}

                <button
                  aria-label="Close"
                  onClick={() => {
                    setIsOpen(false);
                    setLogsModalRows([]);
                  }}
                  style={closeIconBtn}
                  title="Close"
                >
                  ×
                </button>
              </div>
            </div>

            <div style={tableWrap} className="loading-list-chat">
              <table style={tableStyle}>
                <thead>
                  <tr>
                    {/* <th style={thSticky}>ID</th> */}
                    <th style={thSticky}>Contact</th>
                    <th style={thSticky}>Status</th>
                    <th style={thSticky}>Date</th>
                    {/* <th style={thSticky}>Product</th> */}
                    <th style={thSticky}>Category</th>
                    <th style={thSticky}>Contact Name</th>
                    <th style={thSticky}>Message Category</th>
                    <th style={thSticky}>Error Code</th>
                    <th style={thSticky}>Error Description</th>
                  </tr>
                </thead>

                <tbody>
                  {ModalLoading ? (
                    <tr>
                      <td colSpan={10} style={centerCell}>
                        <span style={spinner} /> <div style={{ height: 8 }} />
                        Loading logs…
                      </td>
                    </tr>
                  ) : Array.isArray(LogsModalRows) && LogsModalRows.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={centerCell}>
                        No data found
                      </td>
                    </tr>
                  ) : (
                    LogsModalRows.map((item) => (
                      <tr key={item.id}>
                        {/* <td style={tdStyle}>{item.id}</td> */}
                        <td style={tdStyle}>{item.contact}</td>
                        <td style={tdStyle}>   <StatusBadge status={item.status} /></td>
                        <td style={tdStyle}>{item.indate}</td>
                        {/* <td style={tdStyle}>{item.product}</td> */}
                        <td style={tdStyle}>{item.category}</td>
                        <td style={tdStyle}>{item.contact_name || "N/A"}</td>
                        <td style={tdStyle}>{item.message_category}</td>
                        <td style={tdStyle}>{item.error_code || "N/A"}</td>
                        <td style={tdStyle}>{item.error || "N/A"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div style={footerBar}>
              {Array.isArray(LogsModalRows) && LogsModalRows.length > 0 && (
                <button onClick={downloadExcelModal} style={primaryBtn}>
                  Download Excel
                </button>
              )}
              <button
                onClick={() => {
                  setIsOpen(false);
                  setLogsModalRows([]);
                }}
                style={dangerBtn}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Logs;
